import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getImgixUrl } from '../../../../helpers';
import Link from '../../../shared/Link/Link';
import cn from 'classnames';
import './SpeakerBlock.scss';

function SpeakerBlock(props) {
  const {
    siteType,
    pageConfig: { tenantId } = {},
    speaker: {
      company,
      forename,
      surname,
      jobTitle,
      photo = null,
      path,
      honorific = '',
      displayHonorific,
      hideCompanyName,
      middleName = '',
    } = {},
  } = props;

  const backgroundImage = getImgixUrl(
    tenantId,
    photo,
    'fit=clamp&w=80&h=80',
    '/images/default-silhouette.png',
  );
  const pagePath = siteType === 'COURSE' ? 'trainers' : 'speakers';

  const companyBlockClassName = cn('c-speaker-block__company', {
    'c-speaker-block__company-hide': hideCompanyName,
  });

  return (
    <Link to={`/${pagePath}/${path}/`} event className="c-speaker-block">
      <div
        className="c-speaker-block__photo lazy"
        data-background-image={backgroundImage}
      />
      <div className="c-speaker-block__content">
        <p className="c-speaker-block__name" data-testid="speaker-block-name">
          {displayHonorific && honorific} {forename} {middleName} {surname}
        </p>
        <p className="c-speaker-block__job">{jobTitle}</p>
        <p className={companyBlockClassName}>{company}</p>
      </div>
    </Link>
  );
}

SpeakerBlock.propTypes = {
  siteType: PropTypes.oneOf(['EVENT', 'COURSE']),
  speaker: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    pageConfig: state.pageConfig,
  };
}

export default connect(mapStateToProps)(SpeakerBlock);
